import React from "react";
import { Modal, ModalBody } from "reactstrap";

import { withTranslation } from "react-i18next";
import crossIcon from "assets/images/cross.svg";
import styles from "accountOwner/pages/Notes/Notes.module.scss";
import Button from "components/Button";
import Text from "components/Text";

const InvitationRequestModal = ({
  t,
  isModalOpen,
  closeModal,
  handleConfirm,
}) => {
  return (
    <Modal
      isOpen={isModalOpen}
      toggle={closeModal}
      className="modal-lg modal-dialog-centered"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={closeModal}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <div className={styles.alert_popup_content_wrapper}>
          <h2 className="page-title text-center mt-3">
            {t("scheduler.invitationRequestModalHeading")}
          </h2>
          <Text
            size="16px"
            weight="300"
            color="#535B5F"
            marginTop="30px"
            lineHeight="24px"
            className="text-center"
          >
            {t("scheduler.invitationRequestModalSubHeading")}
          </Text>

          <div className={styles.main_btn_container}>
            <Button onClick={handleConfirm} className="w-50">
              {t("scheduler.invitationRequestModalSendButton")}
            </Button>
            <Button borderedSecondaryNew onClick={closeModal} className="w-50">
              <span>{t("cancel")}</span>
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default withTranslation()(InvitationRequestModal);
